import Vue from 'vue';
import Vuex from 'vuex';
import UsersModule from './modules/users';
import SitesModule from './modules/sites';
import CustomersModule from './modules/customers';
import PricesModule from './modules/prices';
import EstimatesModule from './modules/estimates';
import BuildingsModule from './modules/buildings';
import axios from 'axios'; 

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    'users': UsersModule,
    'sites': SitesModule,
    'customers': CustomersModule,
    'prices': PricesModule,
    'estimates': EstimatesModule,
    'buildings': BuildingsModule
  },

  state: {
    globalMessages: [],
    loadingFiles: 0
  },

  getters: {
    loadingFiles: state => state.loadingFiles != 0
  },

  mutations: {
    ADD_MESSAGE(state, message) {
      state.globalMessages = [message, ...state.globalMessages];
    },
    POP_MESSAGE(state) {
      if (state.globalMessages.length > 0) state.globalMessages.pop();
    },
    SET_LOADING_FILE(state) {
      state.loadingFiles++;
    },
    REMOVE_LOADING_FILE(state) {
      state.loadingFiles--;
    }
  },

  actions: {
    showMessage({ state, commit }, message) {
      if (!state.globalMessages.find(x => x == message)) {
        commit('ADD_MESSAGE', message);
      }
    },

    async loadFile({ commit }, file) {
      commit('SET_LOADING_FILE');
      try {
        let formData = new FormData();
        formData.append('file', file, file.name);
        let res = await axios.put('api/files/', formData, { timeout: 60000 });
        return res.data;
      } catch(err) {
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_FILE'); 
      }
    },
  },
})
